export const FLEXGEN_CONTAINER_QUANTITY = 'FLEXGEN_CONTAINER_QUANTITY'
export const FLEXGEN_CONTAINER_DIRECTION = 'FLEXGEN_CONTAINER_DIRECTION'
export const FLEXGEN_CONTAINER_WRAP = 'FLEXGEN_CONTAINER_WRAP'
export const FLEXGEN_CONTAINER_JC = 'FLEXGEN_CONTAINER_JC'
export const FLEXGEN_CONTAINER_AI = 'FLEXGEN_CONTAINER_AI'
export const FLEXGEN_CONTAINER_AC = 'FLEXGEN_CONTAINER_AC'
export const FLEXGEN_CONTAINER_AS = 'FLEXGEN_CONTAINER_AS'
export const FLEXGEN_ITEMS = 'FLEXGEN_ITEMS'
export const FLEXGEN_COLLAPSE = 'FLEXGEN_COLLAPSE'
export const FLEXGEN_HTML = 'FLEXGEN_HTML'
export const FLEXGEN_CSS = 'FLEXGEN_CSS'

export const GRIDGEN_SECTIONS = 'GRIDGEN_SECTIONS'
export const GRIDGEN_SELECTED_SECTIONS = 'GRIDGEN_SELECTED_SECTIONS'
export const GRIDGEN_SELECTED_SECTIONS_CLEAR = 'GRIDGEN_SELECTED_SECTIONS_CLEAR'
export const GRIDGEN_ROWS = 'GRIDGEN_ROWS'
export const GRIDGEN_COLS = 'GRIDGEN_COLS'
export const GRIDGEN_HTML = 'GRIDGEN_HTML'
export const GRIDGEN_CSS = 'GRIDGEN_CSS'
